import { apiHelper } from "../redux/apiHelper";

// Get all package pricings
export const getPackagePricings = async () => {
  try {
    let res = await apiHelper("get", `/api/admin/package-pricing`);
    if (res) {
      return res;
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};

// Get single package pricing by ID
export const getPackagePricingById = async (id) => {
  try {
    let res = await apiHelper("get", `/api/admin/package-pricing/${id}`);
    if (res) {
      return res;
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};

// Create package pricing
export const createPackagePricing = async (data) => {
  try {
    let res = await apiHelper("post", `/api/admin/package-pricing/create`, data);
    if (res) {
      return res;
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};

// Update package pricing
export const updatePackagePricing = async (id, data) => {
  try {
    let res = await apiHelper("post", `/api/admin/package-pricing/update/${id}`, data);
    if (res) {
      return res;
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};

// Delete package pricing
export const deletePackagePricing = async (id) => {
  try {
    let res = await apiHelper("delete", `/api/admin/package-pricing/delete/${id}`);
    if (res) {
      return res;
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};

// Get active pricing by package type
export const getActivePricingByPackage = async (packageType) => {
  try {
    let res = await apiHelper("get", `/api/admin/package-pricing/package/${packageType}`);
    if (res) {
      return res;
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};

